<div>
  <lightgallery [settings]="settings" [onBeforeSlide]="onBeforeSlide" class="masonry" *ngIf="imageUrls">
    <a *ngFor="let url of imageUrls; first as isFirst" [href]="url" class="masonry-brick masonry-brick--h"
      [class.overlay]="isFirst">
      <img [src]="url" />
    </a>

  </lightgallery>
</div>